import React from 'react';

import { Input, type TypeInputProps } from '@thefarmersfront/kitchen';

import type { CustomCellRendererProps } from 'ag-grid-react';
import clsx from 'clsx';

import styles from './TableCellRenderer.module.scss';

export type TypeTextInputCellParams = Pick<
  TypeInputProps,
  'placeholder' | 'disabled' | 'count' | 'maxLength' | 'maxWidth' | 'status' | 'validationMessage'
> & {
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  isModified?: boolean;
};

export type TypeTextInputCellProps<TData, TValue> = CustomCellRendererProps<TData, TValue> & TypeTextInputCellParams;

const TextInputCell = <TData, TValue extends string>({
  value,
  placeholder,
  disabled,
  count,
  maxLength,
  maxWidth,
  status,
  validationMessage,
  onChange,
  onBlur,
  isModified,
}: TypeTextInputCellProps<TData, TValue>) => {
  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const handleBlurInput = (e: React.FocusEvent<HTMLInputElement>) => {
    onBlur?.(e.target.value);
  };

  return (
    <div className={styles['cell-wrapper']}>
      <Input
        className={clsx(styles['text-input'], isModified && styles['modified'])}
        type="text"
        size="tiny"
        value={value ?? ''}
        placeholder={placeholder ?? '입력'}
        status={status}
        validationMessage={validationMessage}
        disabled={disabled ?? false}
        count={count}
        maxLength={maxLength}
        maxWidth={maxWidth}
        onChange={handleChangeInput}
        onBlur={handleBlurInput}
      />
    </div>
  );
};

export default TextInputCell;
